import React from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { defaultLayoutSearch, gridSearchLayout, tableSearchLayout } from "../../site/configuration/defaultSettings";

// Global url parameters to preserve cross-routing
const GLOBAL_PARAMS: string[] = ["rmode"];

function getPath(queryString: string, newPath: string): string {
  const searchParams = new URLSearchParams(queryString);
  const searchParamsOut = new URLSearchParams("");
  GLOBAL_PARAMS.forEach((param) => {
    const paramValue = searchParams.get(param);
    if (paramValue) {
      if (
        newPath &&
        newPath.indexOf("?" + param + "=" + paramValue) === -1 &&
        newPath.indexOf("&" + param + "=" + paramValue) === -1
      ) {
        searchParamsOut.set(param, paramValue);
      }
    }
  });

  if (
    searchParamsOut.toString() === undefined ||
    searchParamsOut.toString() === ""
  ) {
    return newPath;
  } else if (newPath.indexOf("?") > 0) {
    return `${newPath}&${searchParamsOut.toString()}`;
  } else {
    return `${newPath}?${searchParamsOut.toString()}`;
  }
}

// Special hook to use instead of useNavigate directly, to handle
// automatically special url params like rmode
export function useNavigationParams() {
  const navigate = useNavigate();
  const location = useLocation();

  const push: (path: string) => void = (path: string) => {
    const newPath = getPath(location.search, path);
    navigate(newPath, { replace: false });
  };

  const replace: (path: string) => void = (path: string) => {
    const newPath = getPath(location.search, path);
    navigate(newPath, { replace: true });
  };

  return { push, replace };
}

interface RedirectWithUrlParamsParams {
  to: string;
  push?: boolean;
}

// Special redirect component, to handle
// automatically special url params like rmode
export const RedirectWithUrlParams: React.FC<RedirectWithUrlParamsParams> = ({
  to,
  push = false,
}) => {
  const location = useLocation();
  const newPath = getPath(location.search, to);

  return <Navigate to={newPath} replace={!push} />;
};


export const decodeURIComponentSafe = (s: string) => {
  if (!s) {
    return s;
  }
  return decodeURIComponent(s.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'));
  
};

export const  getLayoutSearch = () => {
        var _layoutSearch = window.localStorage.getItem("layoutSearch");
        if (
            _layoutSearch === null ||
            _layoutSearch === undefined ||
            (_layoutSearch !== tableSearchLayout &&
            _layoutSearch !== gridSearchLayout )
        ) {
            setLayoutSearch(defaultLayoutSearch);
            _layoutSearch = defaultLayoutSearch;
        }
        return _layoutSearch;
    };

 export const setLayoutSearch = (layoutSearch?: string) => {
     window.localStorage.setItem(
         "layoutSearch",
         layoutSearch ?? defaultLayoutSearch
     );
     return layoutSearch;
 };
